import {slices} from 'store';
import {load, loadSearch, syncFolder, download} from 'utils/mediafire';

import type {Store, FilesPick, FilesItem} from 'store/slices/files/types';
import type {NavigateFunction} from 'react-router';
import type {Dispatch} from 'redux';

// GENERAL

export function layout(dispatch: Dispatch) {
  return () => {
    dispatch(slices.files.actions.layout());
  }
}

export function sort(navigate: NavigateFunction, dispatch: Dispatch, id: string) {
  return (sort: Store['sort'], filter: Store['filter']) => {
    dispatch(slices.files.actions.sort(sort));
    syncFolder(navigate, dispatch, id, -1, -1, -1, sort, filter);
  }
}

export function filter(navigate: NavigateFunction, dispatch: Dispatch, id: string) {
  return (sort: Store['sort'], filter: Store['filter']) => {
    dispatch(slices.files.actions.filter(filter));
    syncFolder(navigate, dispatch, id, -1, -1, -1, sort, filter);
  }
}

export function search(navigate: NavigateFunction, dispatch: Dispatch, id: string | null, term?: string) {
  return () => {
    const query = term && typeof term === 'string' && term.length >= 3 && term;
    query && loadSearch(navigate, dispatch, id, query);
    dispatch(slices.files.actions.search({id, query}));
  }
}

export function downloadFile(url: string, forceDownload?: true) {
  return (e: any) => {
    e.stopPropagation && e.stopPropagation();
    download(url, false, forceDownload);
  }
}

// Picker

export function pick(dispatch: Dispatch, context: FilesPick) {
  return (e?: any) => {
    e && e.stopPropagation && e.stopPropagation();
    dispatch(slices.files.actions.pick(context));
  }
}

export function pickClear(dispatch: Dispatch) {
  dispatch(slices.files.actions.pick(null));
}

export function pickSubmit(pick: FilesPick, navigate: NavigateFunction, dispatch: Dispatch) {
  return (item?: FilesItem) => {
    if (item)
      load(navigate, dispatch, item.id);
    if (pick) {
      const {ids, action} = pick;
      dispatch(slices.files.actions.pick({ids, action, destination: item.id}));
    } else {
      dispatch(slices.files.actions.pick(null));
    }
  }
}

// SELECTING

export function selectClear(dispatch: Dispatch, id: string | null) {
  return (e: any) => {
    dispatch(slices.files.actions.select({ids: id ? [id] : []}));
    e.stopPropagation && e.stopPropagation();
  }
}
